import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CircularProgress } from '@mui/material';
import { Button } from '../../../ui-components';
import apiCall from '../../../utils/apiCall';

// Interface for each applicant item
interface Applicant {
  ApplicantId: string;
  FirstName: string;
  LastName: string;
  ApplicationDate: string;
  Gender: string | null;
  MaritalStatusId: number;
  MaritalStatus: string;
  Email: string;
}

// Interface for full API response
interface ApplicantApiResponse {
  TotalSize: number;
  StatusCode: number;
  Message: string;
  Data: Applicant[];
}

// Fetch function with query params
const getAllApplicants = async (
  pageNumber: number,
  pageSize: number,
  startDate: string,
  endDate: string,
  search: string
): Promise<ApplicantApiResponse> => {
  const queryParams = new URLSearchParams({
    PageNumber: pageNumber.toString(),
    PageSize: pageSize.toString(),
    sDate: startDate,
    eDate: endDate,
    search: search,
  });

  const response = await apiCall().get(`/Applicant/GetAllDisabledUser?${queryParams}`)
  ;
  return response?.data;
};

const DisplayApplicant = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(10);
  const [searchData, setSearchData] = useState('');
  const [startDate] = useState('2025-01-01T00:00:00');
  const [endDate] = useState('2025-04-10T23:59:59');

  const { data, error, isLoading } = useQuery(
    ['getAllApplicants', pageNumber, pageSize, startDate, endDate, searchData],
    () => getAllApplicants(pageNumber, pageSize, startDate, endDate, searchData),
    { retry: 0, refetchOnWindowFocus: false }
  );

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchData(event.target.value);
    setPageNumber(1);
  };

  const handleNextPage = () => {
    if (data && pageNumber < Math.ceil(data.TotalSize / pageSize)) {
      setPageNumber(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(prev => prev - 1);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '16px', display: 'flex', gap: '10px' }}>
        <input
          type="text"
          placeholder="Search applicants..."
          value={searchData}
          onChange={handleSearchChange}
          style={{ padding: '8px', width: '250px' }}
        />
        <Button onClick={handlePrevPage} disabled={pageNumber === 1}>
          Prev Page
        </Button>
        <Button
          onClick={handleNextPage}
          disabled={data ? pageNumber >= Math.ceil(data.TotalSize / pageSize) : false}
        >
          Next Page
        </Button>
      </div>

      {isLoading ? (
        <CircularProgress />
      ) : error ? (
        <div>Error loading applicants</div>
      ) : data?.Data && data.Data.length > 0 ? (
        <div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {/* <th style={{ padding: '10px', border: '1px solid #ddd' }}>Applicant ID</th> */}
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>First Name</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Last Name</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Email</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Marital Status</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Application Date</th>
              </tr>
            </thead>
            <tbody>
              {data.Data.map(applicant => (
                <tr key={applicant.ApplicantId}>
                  {/* <td style={{ padding: '8px', border: '1px solid #ddd' }}>{applicant.ApplicantId}</td> */}
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{applicant.FirstName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{applicant.LastName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{applicant.Email}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{applicant.MaritalStatus}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {new Date(applicant.ApplicationDate).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ marginTop: '12px' }}>
            Page {pageNumber} of {Math.ceil(data.TotalSize / pageSize)}
          </p>
        </div>
      ) : (
        <div>No applicants found</div>
      )}
    </div>
  );
};

export default DisplayApplicant;
